// export const baseUrl = 'http://192.168.1.9:15680'

export const baseUrl = "https://admin.3powerserv.com/api"
